import Vue from 'vue';
import VueRouter from 'vue-router';
import crmRoutes from './crmRoutes';
import designRoutes from './designRoutes';
import dialogRoutes from './dialogRoutes';
import widgetRoutes from './widgetRoutes';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [...widgetRoutes, ...dialogRoutes, ...designRoutes, ...crmRoutes],
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.path.startsWith('/design') && to.path !== from.path) {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
